module.exports = "https://activity.hdslb.com/blackboard/activity92636/img/tanbai-card-poster.da1c74d8.png";